/*
 * Cart minimum quantity for a specific product
 * -------------------------------------------------
 * Blocks checkout (cart page + cart drawer) and shows a message when a
 * configured product is present in the cart below a required minimum.
 * Config is injected from cart-drawer.liquid as window.themeCartMinQty:
 *   { productName: String, min: Number, message: String }
 *
 * Matching is by product name (case-insensitive) rather than product ID,
 * because Inky Bay generates a brand new product (e.g. "Personalized DRAFT
 * TOP LIFT") at the moment the personalized item is added to the cart, so
 * there is no fixed product ID to target.
 *
 * The setting is edited in the theme customizer (Cart drawer section >
 * "Product minimum quantity"). The rule only applies when the product is
 * actually in the cart; an empty cart or a cart without the product is
 * never blocked.
 */
(function () {
  'use strict';

  var ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var checking = false;

  function config() {
    return window.themeCartMinQty || {};
  }

  function isActive() {
    var c = config();
    return !!(c.productName && c.min > 0);
  }

  function fillTokens(str, qty) {
    var c = config();
    return String(str)
      .replace(/\[min\]/g, c.min)
      .replace(/\[current\]/g, qty)
      .replace(/\[product\]/g, c.productName || 'this product');
  }

  // Normalize a name for comparison: lowercase + collapse whitespace.
  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getMessageEl(form) {
    var existing = form.querySelector('.cart-min-qty-message');
    if (existing) return existing;
    var anchor = form.querySelector('.checkout-buttons');
    if (!anchor || !anchor.parentNode) return null;
    var msg = document.createElement('div');
    msg.className = 'cart-min-qty-message';
    msg.setAttribute('role', 'alert');
    msg.hidden = true;
    anchor.parentNode.insertBefore(msg, anchor);
    return msg;
  }

  function apply(enforce, qty) {
    var forms = document.querySelectorAll('cart-form');
    for (var i = 0; i < forms.length; i += 1) {
      var form = forms[i];
      var pageBtn = form.querySelector('button[name="checkout"]'); // cart page
      var drawerLink = form.querySelector('.checkout-buttons a.btn'); // drawer
      var dynamicBtns = form.querySelector('.additional-checkout-buttons'); // Shop Pay etc.
      var msg = getMessageEl(form);

      if (enforce) {
        if (msg) {
          msg.textContent = fillTokens(config().message, qty);
          msg.hidden = false;
        }
        if (pageBtn) {
          pageBtn.disabled = true;
          pageBtn.setAttribute('aria-disabled', 'true');
          pageBtn.classList.add('cart-min-qty-disabled');
        }
        if (drawerLink) {
          var href = drawerLink.getAttribute('href');
          if (href) drawerLink.dataset.minHref = href;
          drawerLink.removeAttribute('href');
          drawerLink.setAttribute('aria-disabled', 'true');
          drawerLink.classList.add('cart-min-qty-disabled');
        }
        if (dynamicBtns) dynamicBtns.hidden = true;
      } else {
        if (msg) msg.hidden = true;
        if (pageBtn) {
          pageBtn.disabled = false;
          pageBtn.removeAttribute('aria-disabled');
          pageBtn.classList.remove('cart-min-qty-disabled');
        }
        if (drawerLink) {
          if (drawerLink.dataset.minHref) {
            drawerLink.setAttribute('href', drawerLink.dataset.minHref);
          }
          drawerLink.removeAttribute('aria-disabled');
          drawerLink.classList.remove('cart-min-qty-disabled');
        }
        if (dynamicBtns) dynamicBtns.hidden = false;
      }
    }
  }

  function check() {
    if (!isActive()) {
      apply(false, 0);
      return;
    }
    if (checking) return;
    checking = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var c = config();
        var target = normalize(c.productName);
        var qty = 0;
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i];
          // Inky Bay's generated product name lives in product_title; fall
          // back to the full line title. Use "contains" so minor suffixes
          // still match.
          var name = normalize(item.product_title || item.title);
          if (name && (name === target || name.indexOf(target) !== -1)) {
            qty += item.quantity;
          }
        }
        apply(qty > 0 && qty < c.min, qty);
      })
      .catch(function () {
        // Fail open: never block checkout because of a network hiccup.
      })
      .then(function () {
        checking = false;
      });
  }

  var timer;
  function checkSoon() {
    clearTimeout(timer);
    timer = setTimeout(check, 250);
  }

  // Re-evaluate after the theme's AJAX cart merge and on any cart change.
  document.addEventListener('on:cart:after-merge', checkSoon);
  document.addEventListener('on:cart:change', checkSoon);
  // Re-evaluate in the theme editor when a section reloads.
  document.addEventListener('shopify:section:load', checkSoon);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();